var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardlogo4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFF8E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.601983,
    y: 0.401787,
    width: 43.1964,
    height: 43.1964,
    rx: 21.5982,
    stroke: "#F5811B",
    strokeOpacity: 0.1,
    strokeWidth: 0.803575
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1064 16.9331L13.8721 17.757C12.9864 18.3468 12.5436 18.6417 12.3034 19.0916C12.0632 19.5425 12.0653 20.0715 12.0693 21.1285C12.0734 22.4033 12.0855 23.7004 12.118 25.0138C12.196 28.1299 12.2345 29.6875 13.3806 30.8326C14.5257 31.9777 16.1046 32.0182 19.2623 32.0973C21.2208 32.1462 23.1803 32.1462 25.1388 32.0973C28.2965 32.0182 29.8753 31.9787 31.0205 30.8326C32.1656 29.6875 32.2051 28.1299 32.2831 25.0138C32.3155 23.7004 32.3277 22.4033 32.3318 21.1295C32.3348 20.0715 32.3368 19.5425 32.0967 19.0926C31.8575 18.6417 31.4147 18.3468 30.529 17.757L29.2937 16.9331",
    stroke: "#FFC70A",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0664 19.9733L19.0719 24.1767C20.596 25.0908 21.358 25.5468 22.2002 25.5468C23.0423 25.5468 23.8043 25.0908 25.3285 24.1757L32.3339 19.9733",
    stroke: "#FFC70A",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1064 22V15.9197C15.1064 14.0085 15.1064 13.0539 15.7003 12.46C16.2941 11.8662 17.2487 11.8662 19.1599 11.8662H25.2402C27.1514 11.8662 28.106 11.8662 28.6999 12.46C29.2937 13.0539 29.2937 14.0085 29.2937 15.9197V22M20.1733 19.9732H24.2268M20.1733 15.9197H24.2268",
    stroke: "#FFC70A",
    strokeWidth: 1.52006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardlogo4);
export default __webpack_public_path__ + "static/media/dashboardlogo4.1407199468c13c9337669fa4b03f1e17.svg";
export { ForwardRef as ReactComponent };